import { CompositeMergeResponseDto, CompositeProjectMetadataDto, PageContextOfProjectDataFilter, VariableDto, VariablesFilterOptionsDto, DataCollectionVariableModel } from "app/ApiClient";
import { ProjectDataTableConfig} from 'const/projectVariables';
import { DEFAULT_BATTERIES } from "slices/batteries/batteriesState";
import { LoadingState, VariablesBatteryGroupSelectableType, VariablesBatteryGroupsType } from "types";

import { BaseState } from "..";

export const initialPageContext: PageContextOfProjectDataFilter = {
  filter: {
    batteries: DEFAULT_BATTERIES,
  },
  page: {
    pageSize: ProjectDataTableConfig.DefaultPageSize,
    pageNumber: 1,
  },
};

export interface VariableSearchQueryType {
  variableSearchDV: boolean;
  variableSearchRespondables: boolean;
  variableSearchString: string;
}

export default interface ProjectsDataState extends BaseState {
  variablesBatteryGroups: VariablesBatteryGroupsType[];
  total: number;
  isGenerateDictionaryDataDialogOpened: boolean;
  currentVariable: VariableDto | null;
  updateVariableLoadingState?: LoadingState;
  updateVariableLoadingError?: string;
  showLoadingError: boolean;
  upsertVariablesLoadingState: LoadingState;
  resetFilters?: boolean;
  respondentsCount: number;
  respondentsCountLoading:boolean;
  pageContext: PageContextOfProjectDataFilter;
  tableFiltersOptions: VariablesFilterOptionsDto[];
  tableFiltersOptionsLoading: LoadingState;
  respondentsErrorMessage?: string;
  currentStackId: number | null;
  currentVersionId: string | null;
  currentModificationId: number | null;
  hiddenColumns: string[];
  compositeProjectMetadata: CompositeProjectMetadataDto| null;
  compositeProjectLoadingState: LoadingState,
  compoisteProjectMergeStatus: LoadingState, 
  compositeProjectMergeResponse: CompositeMergeResponseDto | null,
  activeVariableTabView: string,
  variableAlert: string,
  variableSearchQuery: VariableSearchQueryType,
  includedVariables: VariablesBatteryGroupSelectableType[],
  excludedVariables: VariablesBatteryGroupSelectableType[],
  isAllIncludedRowsSelected:boolean,
  isIncludeRowInDeterminent:boolean,
  isAllExcludedRowsSelected:boolean,
  isExcludedRowInDeterminent:boolean,
  metadataVariables: DataCollectionVariableModel[], 
  metadataVariablesState: LoadingState;
}

export const originProjectsDataState: ProjectsDataState = {
  variablesBatteryGroups: [],
  hiddenColumns: [],
  processing: false,
  finished: false,
  failed: false,
  succeed: false,
  error: "",
  total: 0,
  isGenerateDictionaryDataDialogOpened: false,
  currentVariable: null,
  showLoadingError: false,
  upsertVariablesLoadingState: LoadingState.idle,
  resetFilters: false,
  respondentsCount: 0,
  respondentsCountLoading:false,
  pageContext: initialPageContext,
  tableFiltersOptions: [],
  tableFiltersOptionsLoading: LoadingState.idle,
  currentStackId: null,
  currentVersionId: null,
  currentModificationId: null,
  compositeProjectMetadata : null,
  compositeProjectLoadingState: LoadingState.idle,
  compoisteProjectMergeStatus: LoadingState.idle, 
  compositeProjectMergeResponse : null,
  activeVariableTabView: "IncludedVariableTab",
  variableAlert: "",
  variableSearchQuery: { variableSearchDV: false, variableSearchRespondables: false, variableSearchString: "" },
  includedVariables: [],
  excludedVariables:[],
  isAllIncludedRowsSelected:false,
  isIncludeRowInDeterminent:false,
  isAllExcludedRowsSelected:false,
  isExcludedRowInDeterminent:false,
  metadataVariables: [], 
  metadataVariablesState: LoadingState.idle
};
